import React from "react";
import { object, number, bool } from "prop-types";

import NewsWithImage from "../../../molecules/NewsWithImage";
import NewsWithNoImage from "../../../molecules/NewsWithNoImage";

import "./oranism.m.css";

const Organism = ({ stories, colNumber, styles, showSubHeading }) => {
  return (
    <div styleName={`base news-wrapper base-${colNumber}`} className={`news-wrapper`}>
      <div styleName="first-story">
        {stories.length > 0 && (
          <NewsWithImage
            story={stories[0].story}
            aspectRatio={[16, 9]}
            imageType="image16x9"
            datatrackinglabelpos={12}
            showDot={true}
            styles={styles}
            showSubHeading={showSubHeading}
          />
        )}
      </div>
      <div styleName="rest-stories">
        {stories.length > 1 &&
          stories
            .slice(1, 4)
            .map(({ story }, index) => (
              <NewsWithNoImage
                key={index}
                story={story}
                showDot={true}
                showExcerpt={false}
                styles={styles}
                showSubHeading={showSubHeading}
              />
            ))}
      </div>
    </div>
  );
};

Organism.propTypes = {
  stories: object.isRequired,
  colNumber: number,
  styles: object,
  showSubHeading: bool,
};

export default Organism;
